<template>
  <div>
    <back-route-hdr :back-mode="'static'"></back-route-hdr>
    <!-- 会议详情相关 -->
    <div v-if="mDoc.subject" :class="'ctn-'+cellData.statusStyle"
         :style="'margin-bottom: '+ (btnList.list.length ? 85: 15) + 'px'">
      <div class="mt-header">
        <div class="text-right">
          <van-tag v-if="cellData.isPeriodic" type="success" plain class="mar-lft-5">周期</van-tag>
          <van-tag type="primary" plain class="mar-lft-5">{{cellData.meetingModeCN}}</van-tag>
          <van-tag v-if="showPermits.meetingType" type="primary" plain class="mar-lft-5">{{cellData.typeCN}}</van-tag>
          <van-tag v-show="identityTag" type="primary" plain class="mar-lft-5">{{identityTag}}</van-tag>
          <van-tag :type="cellData.statusStyle" plain class="mar-lft-5">{{cellData.statusCN}}</van-tag>
        </div>
        <h3 class="mar-top-10">
          <span>{{cellData.subject}}</span>
        </h3>
        <div class="mt-header-time">
          <div class="text-center">
            <div class="time-title">{{cellData.startTime}}</div>
            <div class="mar-top-5 font-size-13">{{cellData.startDate}}</div>
          </div>
          <div class="van-progress flex-center">
            <span class="van-progress__pivot">{{cellData.durationCN}}</span>
          </div>
          <div class="text-center">
            <div class="time-title">{{cellData.endTime}}</div>
            <div class="mar-top-5 font-size-13">{{cellData.endDate}}</div>
          </div>
        </div>
      </div>

      <div v-if="cellData.isPeriodic" class="mt-container mar-hor mar-btm-10">
        <van-cell-group class="mt-detail pad-top-5">
          <van-cell title="周期重复频率" :icon="' iconfont '+titleIcons.periodicReserve"
                    :value="cellData.periodicTypeCN"></van-cell>
          <van-divider class="mar-top-0 mar-btm-0"></van-divider>
          <van-cell title="周期会议场数" :icon="' iconfont '+titleIcons.quantity"
                    is-link @click="showPeriodicList = true"
                    :value="periodicMts.length+'场（查看）'"></van-cell>
        </van-cell-group>
      </div>

      <div class="mt-container mar-hor mar-btm-10">
        <van-cell-group class="mt-detail pad-top-5">
          <van-collapse v-if="cellData.teleconferenceType && hasInvitationInfo" v-model="tlcActName">
            <van-collapse-item :name="normalStatus? '1' : '0'"
                               :disabled="!(identity.owner || identity.ccTo)">
              <template #title>
                <div>
                  <i :class="'iconfont ' + titleIcons.teleconference" class="mar-rgt-5"></i>
                  <tlc-logo :tlc-manufacturer="cellData.tlcManufacturer"></tlc-logo>
                  <span> {{tlcConferenceNum}}</span>
                </div>
              </template>
              <tlc-invitation :m-doc="mDoc"
                              :teleconference-info="cellData.teleconferenceInfo"
                              :reserved-permit="identity.editor"
                              :status-permit="normalStatus"></tlc-invitation>
            </van-collapse-item>
          </van-collapse>
          <van-cell v-else-if="cellData.teleconferenceType">
            <template #title>
              <div>
                <i :class="'iconfont ' + titleIcons.teleconference" class="mar-rgt-5"></i>
                <tlc-logo :tlc-manufacturer="cellData.tlcManufacturer"></tlc-logo>
                <span> {{tlcConferenceNum}}</span>
              </div>
            </template>
          </van-cell>

          <van-cell v-show="cellData.roomNum" :icon="' iconfont '+titleIcons.meetingRoom">
            <template #title>
              <span>{{cellData.roomName}}{{cellData.roomCost && showPermits.meetingCost ? `（共￥${cellData.roomCost}）` : ''}}</span>
              <van-icon v-show="cellData.roomPics.length" @click="showRoomPics=true"
                        class="text-lg pull-right mar-top-5" name="photo"></van-icon>
            </template>
            <template #label>
              <div>{{cellData.roomNum}}</div>
              <div v-show="cellData.deviceExceptionTip">
                <span class="text-sm text-danger line-hgt">* {{cellData.deviceExceptionTip}}</span>
              </div>
            </template>
          </van-cell>
          <van-cell v-show="reviewProcessLabel" :icon="' iconfont '+titleIcons.reviewProcess"
                    :title="sysFormTitles.reviewProcess + ' - ' + reviewProcessLabel"></van-cell>

          <van-cell v-show="cellData.branchVenueNames" :title="'已选'+sysFormTitles.branchVenues"
                    :icon="' iconfont '+titleIcons.branchVenues"
                    :label="cellData.branchVenueNames"></van-cell>

          <van-cell v-show="cellData.applyEndTime" :icon="' iconfont '+titleIcons.meetingTime">
            <template #title>
              <div>
                <span>预约结束时间 - {{cellData.applyEndTime}}</span>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>

      <div class="mt-container mar-hor mar-btm-10">
        <van-cell-group class="mt-detail pad-top-5">
          <van-cell v-show="showPermits.initiator" :icon="' iconfont '+titleIcons.initiator">
            <template #title>
              <span>{{sysFormTitles.initiator}} - {{cellData.initiatorName}}</span>
            </template>
            <template #label>
              <p v-show="cellData.initiatorDeptNames" class="mar-top-5 mar-btm-0">{{cellData.initiatorDeptNames}}</p>
            </template>
          </van-cell>
          <van-cell v-show="showPermits.sponsor" :icon="' iconfont '+titleIcons.sponsor">
            <template #title>
              <span>{{sysFormTitles.sponsor}} - {{cellData.sponsorName}}</span>
            </template>
            <template #label>
              <p v-show="cellData.sponsorDeptNames" class="mar-top-5 mar-btm-0">{{cellData.sponsorDeptNames}}</p>
            </template>
          </van-cell>
          <van-cell :icon="' iconfont '+titleIcons.createdBy">
            <template #title>
              <span>{{sysFormTitles.createdBy}} - {{cellData.createdBy}}</span>
            </template>
          </van-cell>

          <div v-if="cellData.participants.length>1">
            <van-cell v-show="cellData.seatsArgLen || cellData.participants.length!==cellData.numberOfPeople"
                      :icon="' iconfont '+titleIcons.numberOfPeople"
                      :title="sysFormTitles.numberOfPeople+' - '+ cellData.numberOfPeople">
              <template #right-icon>
                <div v-show="cellData.seatsArgLen">
                  <span class="text-sm text-lt mar-rgt-5">已排座</span>
                  <van-badge color="#2D69E0" :content="cellData.seatsArgLen"></van-badge>
                </div>
              </template>
            </van-cell>
            <van-cell :icon="' iconfont '+titleIcons.insideParticipant">
              <template #title>
                <span>{{sysFormTitles.insideParticipant}}（{{cellData.participants.length}}）</span>
                <div class="pull-right">
                  <span v-if="cellData.participants.length <= 100"
                        class="text-sm text-primary mar-rgt-10" @click="showPsGroupSheet=true">
                      设为会议群组 <i class="iconfont icon-dianji"></i></span>
                  <span class="text-sm" @click="showAttendanceDetail=true">
                      参会详情 <i class="iconfont icon-xiangyou"></i></span>
                </div>
              </template>
              <template #label>
                <div class="participants-ctn">
                  <span v-for="(e) in cellData.participants">
                    {{e.name}}
                    <i v-show="e.attendanceType" :class="attendanceIcon[e.attendanceType]"></i>
                    <i v-show="e.ignoreNotice" class="iconfont icon-tixing-guan"></i>
                  </span>
                </div>
              </template>
            </van-cell>
          </div>
          <div v-else-if="cellData.participants.length">
            <van-cell :icon="' iconfont '+titleIcons.insideParticipant">
              <template #title>
                <span>{{sysFormTitles.insideParticipant}}
                  （{{cellData.participants.length}}）- {{cellData.participants[0].name}}</span>
              </template>
            </van-cell>
          </div>
          <van-cell :title="sysFormTitles.outsideParticipant+'（'+(cellData.outsideParticipant||[]).length+'）'"
                    :icon="' iconfont '+titleIcons.outsideParticipant"
                    v-show="cellData.visitors" :label="cellData.visitors">
            <template #right-icon>
              <span class="pull-right text-sm" @click="showOutsideParticipantDetail=true">
                      参会详情 <i class="iconfont icon-xiangyou"></i></span>
            </template>
          </van-cell>
          <van-cell :title="sysFormTitles.copyTo+'（'+(cellData.copyToUsers||[]).length+'）'"
                    :icon="' iconfont '+titleIcons.copyTo"
                    v-show="cellData.ccUsers" :label="cellData.ccUsers"></van-cell>
          <van-cell v-show="cellData.shouldAttendance > 1 || cellData.actualAttendance"
                    :icon="' iconfont '+titleIcons.statistics">
            <template>
              <span>
                应到 {{cellData.shouldAttendance}} 人，
                实到 {{cellData.actualAttendance}} 人，
                签到率 {{cellData.attendanceRate}}%
              </span>
              <span v-show="cellData.actualAttendance" class="pull-right text-sm text-primary"
                    @click="handleChkDetail">签到详情 <i class="iconfont icon-xiangyou"></i></span>
            </template>
          </van-cell>
        </van-cell-group>
      </div>

      <div v-if="cellData.customerGrade || cellData.serviceDmd || extensionFieldList.length"
           class="mt-container mar-hor mar-btm-10">
        <van-cell-group class="mt-detail pad-top-5">
          <van-cell v-show="cellData.customerGrade" :icon="' iconfont '+titleIcons.customerAttendance"
                    :title="'参会客户级别 - '+ customerGradesMap[cellData.customerGrade]"></van-cell>
          <van-cell v-show="cellData.serviceDmd" :icon="' iconfont '+titleIcons.serviceRequire"
                    :title="sysFormTitles.serviceRequire
                    +(cellData.serviceSumPrice && showPermits.meetingCost ?`（共￥${cellData.serviceSumPrice.toFixed(2)}）`:'')"
                    :label="cellData.serviceDmd"></van-cell>

          <div v-for="ele in extensionFieldList" :key="ele.key">
            <van-cell v-if="ele.more" :title="ele.label" :icon="' iconfont '+(ele.icon || 'icon-jilu')">
              <template #label>
                <p class="mar-top-5 mar-btm-0">{{ele.value}}</p>
              </template>
            </van-cell>
            <van-cell v-else :title="ele.label + ' - ' + ele.value"
                      :icon="' iconfont '+(ele.icon || 'icon-jilu')"></van-cell>
          </div>
        </van-cell-group>
      </div>

      <div class="mt-container mar-hor">
        <van-cell-group class="mt-detail pad-top-5">
          <van-cell v-if="cellData.mtTotalCost && showPermits.meetingCost"
                    :icon="' iconfont '+titleIcons.meetingCost"
                    :title="sysFormTitles.meetingCost + ' - '+ `共￥${cellData.mtTotalCost}`"></van-cell>

          <van-cell v-if="cellData.meetingGrade && showPermits.meetingGrade"
                    :icon="' iconfont '+titleIcons.meetingGrade"
                    :title="sysFormTitles.meetingGrade + ' - ' + cellData.meetingGrade"></van-cell>
          <van-cell v-if="cellData.timeRange && showPermits.timeRange"
                    :icon="' iconfont '+titleIcons.timeRange"
                    :title="sysFormTitles.timeRange + ' - ' + cellData.timeRange"></van-cell>

          <van-cell v-if="cellData.meetingRemarks" title="会议备注"
                    :icon="' iconfont '+titleIcons.meetingRemarks">
            <template #label>
              <p class="mar-top-5 mar-btm-0">{{cellData.meetingRemarks}}</p>
            </template>
          </van-cell>
          <van-cell :title="'是否开启会议提醒 - '+ (cellData.enableNotice ? '是' : '否')"
                    :icon="' iconfont '+titleIcons.meetingNotice">
            <template #label>
              <div v-if="mtNotice">{{mtNotice}}</div>
            </template>
          </van-cell>

          <van-cell v-if="cellData.checkinDate" title="会议已签到" icon=" iconfont icon-zhengque-circle"
                    :value="cellData.checkinDate"></van-cell>
          <van-cell v-if="specialTime.finished" title="手动结束时间" icon=" iconfont icon-jieshu"
                    :value="specialTime.finished" value-class="text-primary"></van-cell>
          <van-cell class="text-danger" v-if="cellData.cancelReason" icon=" iconfont icon-jieshu"
                    :title="'取消原因 - '+cellData.cancelReason"></van-cell>
          <van-cell class="text-danger" v-if="cellData.releaseTextInfo" icon=" iconfont icon-jieshu"
                    :title="cellData.releaseTextInfo"></van-cell>
        </van-cell-group>

        <div v-show="identity.owner || (identity.ccTo && cellData.status==='NOTSTART')"
             class="mt-btm bord-top text-right pad-all-5">
          <van-button v-show="identity.owner && cellData.lvcViewUrl" plain size="small"
                      class="mar-rgt-5" @click="showLvcSharePopup=true">分享直播
          </van-button>
          <van-button v-show="identity.owner && controlIds.lvc" plain size="small"
                      class="mar-rgt-5" @click="handleOperate('startLvc')">开启直播
          </van-button>
          <van-button v-show="identity.owner && controlIds.lvc" plain size="small"
                      class="mar-rgt-5" @click="handleOperate('endLvc')">关闭直播
          </van-button>
          <van-button v-show="identity.owner" plain size="small"
                      @click="handleOperate('copyMt')">
            <i class="iconfont icon-copy mar-rgt-5"></i>再约一场
          </van-button>
          <van-button v-show="identity.ccTo && cellData.status==='NOTSTART'"
                      type="primary" size="small" icon="records"
                      @click="handleOperate('createOther')">组织会议
          </van-button>
        </div>
      </div>

      <div v-show="serviceList.length" class="mar-hor mar-top custom-steps">
        <van-cell-group :title="sysFormTitles.serviceCall">
          <service-swipe-cell :service-list="serviceList"
                              :show-price="showPermits.meetingCost"
                              @reload-service="getMtServiceList"></service-swipe-cell>
        </van-cell-group>
      </div>
    </div>
    <div v-else-if="beforeQuery" class="bg-white pad-top-20 pad-btm-20 mar-all">
      <h3></h3><!--占位-->
      <van-skeleton title :row="10"></van-skeleton>
    </div>
    <div v-else class="mar-hor">
      <empty-notice :desc="'当前会议不存在'"></empty-notice>
    </div>
    <div v-show="btnList.list.length || controlIds.lvc && btnList.more.length">
      <button-tab :list="btnList.list" :more="btnList.more"
                  @handle-cmd="handleOperate"></button-tab>
    </div>

    <van-action-sheet v-model="showDelayPopup" title="快速延迟会议">
      <van-cell-group>
        <van-cell v-for="ele in dlySuggestions" :key="ele.value" center class="bord-btm"
                  :title="`延迟 ${ele.hours} 小时`"
                  :label="`${ele.startTime} - ${ele.endTime}`">
          <template>
            <van-button class="theme-btn" size="small" @click="handleDelay(ele)">立即延迟</van-button>
          </template>
        </van-cell>
      </van-cell-group>
    </van-action-sheet>

    <cancel-sheet :show="showCancelPopup" :params="{mid: mid, isSubUpdate: isSubUpdatePeriodic}" @reload="initMDoc()"
                  @handle-cancel="showCancelPopup = $event"></cancel-sheet>

    <van-popup v-model="showLvcSharePopup" round closeable style="width: 90%">
      <lvc-share-popup :mid="mDoc.mid" :lvc-info="mDoc.liveConferenceInfo"></lvc-share-popup>
    </van-popup>

    <van-action-sheet v-model="showAttendPopup" :title="'参会应答 - '+attendanceTitle[attendanceInfo.main]">
      <van-form label-align="right" label-width="80" @submit="onAttendSubmit" ref="attendanceInfo">
        <van-field v-show="attendanceInfo.main==='accept'" label="参会类型" name="type">
          <template #input>
            <van-radio-group v-model="attendanceInfo.type" direction="horizontal">
              <van-radio name="onSite">{{attendanceTitle.onSite}}</van-radio>
              <van-radio name="remote">{{attendanceTitle.remote}}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-model="attendanceInfo.memo" :label="attendanceMemoNt.label"
                   name="memo" rows="1" autosize type="textarea"
                   :placeholder="attendanceMemoNt.placeholder" :rules="attendanceMemoNt.rule || []"></van-field>
        <div class="mar-all">
          <van-button class="theme-btn" block size="small">提交</van-button>
        </div>
      </van-form>
    </van-action-sheet>

    <van-action-sheet v-model="showPeriodicSheet" :actions="periodicActions"
                      cancel-text="关闭" :description="`确认${operateWord}周期会议`"
                      @select="confirmPeriodic" close-on-click-action></van-action-sheet>
    <van-popup v-model="showPeriodicList" position="bottom" class="static-md-pop">
      <div class="flex flex-column hgt-100-percent">
        <div class="bord-box pad-ver text-center">
          <span class="text-lg text-hv">周期会议</span>
        </div>
        <div class="bord-box bord-btm pad-hor">
          <p class="mar-top-0 mar-btm-10 text-sm text-lt">
            <span class="text-success">{{cellData.periodicTypeCN}}</span>
            结束于{{cellData.periodicUtDate}} {{periodicMts.length}}场会议</p>
        </div>
        <div class="pad-hor pad-btm bord-box auto-overflow">
          <van-cell-group :border="false">
            <van-cell v-for="ele in periodicMtList" :key="ele.mid" @click="handleDetail(ele.mid)"
                      class="bord-btm pad-lft-5 pad-rgt-0" is-link>
              <template #default>
                <div>
                  <span class="mar-rgt-10">{{ele.dateDay}}</span>
                  <span class="mar-rgt-10">{{ele.weekDay}}</span>
                  <span class="mar-rgt-10">{{ele.meetingTime}}</span>
                  <van-tag class="mar-rgt-5" :type="ele.statusStyle">{{ele.statusCN}}</van-tag>
                  <span class="text-sm" v-show="ele.mid===mid">（当前）</span>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showAttendanceDetail" position="bottom" class="static-md-pop">
      <div class="flex flex-column hgt-100-percent">
        <div class="bord-box pad-ver text-center">
          <span class="text-lg text-hv">{{sysFormTitles.insideParticipant}}参会详情</span>
        </div>
        <div class="bord-box bord-btm pad-hor">
          <van-row class="text-hv mar-btm-5">
            <van-col span="12"><span>{{sysFormTitles.insideParticipant}}</span></van-col>
            <van-col span="7"><span>参会应答</span></van-col>
            <van-col span="5"><span>是否签到</span></van-col>
          </van-row>
        </div>
        <div class="pad-hor pad-btm bord-box auto-overflow">
          <div class="bord-btm pad-btm-5 pad-top-10" v-for="ele in cellData.insideParticipant" :key="ele.userId">
            <van-row>
              <van-col span="12" class="pad-rgt-5">
                <span>{{ele.name}}</span>
                <span v-show="ele.attendanceMemo" class="text-sm text-nowrap">（{{ele.attendanceMemo}}）</span>
              </van-col>
              <van-col span="7">
                <span v-if="mDoc.initiator && ele.userId === mDoc.initiator.userId">
                  <i class="iconfont icon-renyuan"></i> {{sysFormTitles.initiator}}</span>
                <span v-else-if="mDoc.sponsor && ele.userId === mDoc.sponsor.userId">
                  <i class="iconfont icon-renyuan"></i> {{sysFormTitles.sponsor}}</span>
                <span v-else-if="mDoc.reservedBy && ele.userId === mDoc.reservedBy.userId">
                  <i class="iconfont icon-yuyueren"></i> {{sysFormTitles.createdBy}}</span>
                <span v-else-if="ele.attendanceType">
                  <i :class="attendanceIcon[ele.attendanceType]"></i> {{attendanceTitle[ele.attendanceType]}}
                </span>
                <span v-else>未应答</span>
              </van-col>
              <van-col span="5" v-show="cellData.roomId">
                <span v-if="ele.checkedIn"><i class="iconfont icon-zhengque-circle"></i> 已签到</span>
                <span v-else>未签到</span>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showOutsideParticipantDetail" position="bottom" class="static-md-pop">
      <div class="flex flex-column hgt-100-percent">
        <div class="bord-box pad-ver text-hv text-center">
          <span class="text-lg text-hv">{{sysFormTitles.outsideParticipant}}详情</span>
        </div>
        <div class="bord-box bord-btm pad-hor pad-btm-5 text-hv">
          <van-row>
            <van-col span="7"><span>{{sysFormTitles.outsideParticipant}}</span></van-col>
            <van-col span="12"><span>联系方式</span></van-col>
            <van-col span="5"><span>是否签到</span></van-col>
          </van-row>
        </div>
        <div class="pad-hor pad-btm bord-box auto-overflow">
          <div class="bord-btm pad-btm-5 pad-top-10" v-for="(ele, idx) in cellData.outsideParticipant" :key="ele.tel">
            <van-row>
              <van-col span="7">
                <span>{{ele.name}}</span>
              </van-col>
              <van-col span="12">
                <span>{{ele.tel}} <van-icon name="eye-o" @click="lookOutUserInfo(ele, idx)"/></span>
              </van-col>
              <van-col span="5" v-show="cellData.roomId">
                <span v-if="ele.checkedIn"><i class="icon-zhengque-circle icon-zhengque-circle"></i> 已签到</span>
                <span v-else>未签到</span>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
    </van-popup>

    <van-image-preview v-model="showRoomPics" :images="cellData.roomPics"></van-image-preview>

    <submit-repair :show="showRepairPopup"
                   :meeting-room-id="cellData.roomId"
                   @handle-cancel="showRepairPopup=$event"></submit-repair>

    <van-action-sheet v-model="showPsGroupSheet" title="设置会议群组">
      <van-form @submit="onPsGroupSubmit">
        <van-cell-group class="mar-btm">
          <template #title>
            <span>会议群组名称（{{psGroupName.length}}/30 字）</span>
            <span class="text-danger">*</span>
          </template>
          <van-field v-model="psGroupName" placeholder="请输入会议群组名称"
                     rows="1" autosize type="textarea" maxlength="30"></van-field>
        </van-cell-group>
        <div class="mar-all">
          <van-button class="theme-btn" block>提交会议群组</van-button>
        </div>
      </van-form>
    </van-action-sheet>
  </div>
</template>

<script>
  import {commonConfig, commonIcons, momentFormat, serviceConfig, tlcConfig} from "../../../../config/common"
  import {
    assembleDemandOptions,
    checkRespCorrect,
    checkShowPermit, formatMListDoc, formatMtDetail,
    formatTlcConferenceNum,
    frontConfirm,
    queryTlcInfoByKey
  } from "../../../../tools/utils"
  import {meeting, meetingRoom, service, personalGroup} from "../../../../server"
  import {messageHdl, msgCode} from "../../../../tools/messageHdlr";
  import {getStorage, StorageKey} from "../../../../tools/storage";
  import routerMeta from "../../router/routerMeta";
  import TlcLogo from "../../components/TlcLogo"
  import TlcInvitation from "../../components/TlcInvitation"
  // import ButtonGroup from "../../components/ButtonGroup"
  import ButtonTab from "../../components/ButtonTab"
  import ServiceSwipeCell from "../../components/ServiceSwipeCell"
  import CancelSheet from "../../components/CancelSheet"
  import LvcSharePopup from "../../components/LvcSharePopup"
  import SubmitRepair from "../operation/SubmitRepair"

  const btnMapKeys = window._ && window._.mapObject(commonConfig.mtBtnMap, (val, key) => key);

  export default {
    components: {
      ServiceSwipeCell,
      // ButtonGroup,
      ButtonTab,
      SubmitRepair,
      CancelSheet,
      LvcSharePopup,
      TlcInvitation,
      TlcLogo
    },
    data() {
      return {
        mid: "",
        mDoc: {}, // 会议数据
        tlcActName: [],

        operateFor: "",
        showDelayPopup: false,
        showCancelPopup: false,
        showRepairPopup: false,
        showLvcSharePopup: false,
        showPsGroupSheet: false,
        psGroupName: "",
        titleIcons: commonIcons.titles,

        beforeQuery: true,
        showAttendPopup: false,
        showAttendanceDetail: false,
        showOutsideParticipantDetail: false,
        showRoomPics: false,
        attendanceInfo: {
          main: "",
          type: "",
          memo: ""
        },
        attendanceTitle: {
          onSite: "现场参会",
          remote: "远程参会",
          accept: "接受参会",
          undetermined: "待定",
          reject: "拒绝"
        },
        attendanceIcon: {
          onSite: "iconfont icon-meetingroom",
          remote: "iconfont icon-huiyimoshi-kongzhitai",
          undetermined: "iconfont icon-bangzhu",
          reject: "iconfont icon-jinyong"
        },
        serviceEdges: [],

        showPeriodicSheet: false,
        isSubUpdatePeriodic: true,
        showPeriodicList: false,
        periodicMts: [],
      }
    },
    computed: {
      userId() {
        return this.$store.state.userId || getStorage(StorageKey.userId)
      },
      sysConfig: function () {
        return this.$store.state.sysConfig || {}
      },
      sysFormTitles() {
        return this.$store.state.formTitles
      },
      controlBtnMap() {
        return {
          ...commonConfig.mtBtnMap,
          clickJoinMeeting: this.sysFormTitles.clickJoinMeeting,
          checkinUnlock: this.sysFormTitles.checkinUnlock,
          serviceCall: this.sysFormTitles.serviceCall,
          deviceRepair: this.sysFormTitles.deviceRepair,
          deviceCtrl: this.sysFormTitles.deviceCtrl,
        }
      },
      serviceStatusMap: function () {
        const obj = {};
        (this.sysConfig.serviceStatus || []).forEach(ele => obj[ele.value] = ele.label);
        return obj
      },
      mgrResourceUrl() {
        return this.$store.state.sysView.mgrSrcUrl || ""
      },

      cellData() {
        return formatMtDetail(this.mDoc, this, this.mgrResourceUrl)
      },
      extensionFieldSettings() {
        const {extensionFieldSettings} = this.$store.state.sysConfig;
        return extensionFieldSettings || []
      },
      extensionFieldList() {
        const data = [];
        this.cellData.extensionFields && this.extensionFieldSettings.forEach(cfg => {
          if (this.cellData.extensionFields.hasOwnProperty(cfg.key)) {
            const destVal = this.cellData.extensionFields[cfg.key];
            let displayVal = destVal;
            try {
              if (cfg.setType === commonConfig.extFields.setTypes.structure) {
                if (cfg.isMulti) {
                  displayVal = (destVal || []).map(e => e.name).join('、')
                } else {
                  displayVal = destVal && destVal.name;
                }
              } else if (cfg.isMulti && Array.isArray(destVal)) {
                displayVal = destVal.join('、')
              }
              displayVal && data.push({
                label: cfg.label,
                icon: cfg.icon,
                value: displayVal,
                more: cfg.isMulti && destVal.length > 3
                  || cfg.setType === commonConfig.extFields.setTypes.textarea,
              })
            } catch (e) {
            }
          }
        });
        // console.log(data)
        return data
      },
      reviewProcessLabel() {
        const sysReviewProcess = this.$store.state.sysConfig.reviewProcess || [];
        const processCode = (this.mDoc || {}).reviewProcessCode;
        if (processCode) {
          return (sysReviewProcess.find(e => e.value === processCode) || {}).label
        }
      },

      specialTime() {
        const createdDate = this.mDoc.createdDate;
        const finishedAt = this.mDoc.finishedInfo && this.mDoc.finishedInfo.date;
        return {
          created: createdDate && moment(createdDate).format(momentFormat.dateFormatMonthDetailCN),
          finished: finishedAt && moment(finishedAt).format(momentFormat.dateFormatMonthDetailCN)
        }
      },
      normalStatus() {
        return commonConfig.normalStatus.includes(this.mDoc.status)
      },
      identity() {
        const {reservedBy, sponsor, initiator, insideParticipant, copyToUsers} = this.mDoc;
        const owners = (insideParticipant || []).concat([reservedBy || {}, sponsor || {}, initiator || {}]);
        const data = {
          reserved: (reservedBy && reservedBy.userId === this.userId),
          sponsor: (sponsor && sponsor.userId === this.userId),
          initiator: (initiator && initiator.userId === this.userId),
        };
        return {
          ...data,
          editor: data.sponsor || data.initiator || data.reserved,
          owner: owners.some(e => e.userId === this.userId),
          ccTo: copyToUsers && copyToUsers.some(e => e.userId === this.userId),
        }
      },
      identityTag() {
        if (this.identity.reserved) {
          return "我预约的"
        }
        if (this.identity.sponsor) {
          return "我主持的"
        }
        if (this.identity.initiator) {
          return "我发起的"
        }
        if (this.identity.owner) {
          return "我参加的"
        }
        if (this.identity.ccTo) {
          return "抄送我的"
        }
      },

      showPermits() {
        const permissionList = this.$store.state.permissionList || [];
        return {
          // 相关人显示权限
          sponsor: checkShowPermit(permissionList, this.permitsMap.sponsor),
          initiator: checkShowPermit(permissionList, this.permitsMap.initiator),

          serviceCall: checkShowPermit(permissionList, this.permitsMap.serviceCall),
          deviceRepair: checkShowPermit(permissionList, this.permitsMap.deviceRepair),
          clickJoinMeeting: checkShowPermit(permissionList, this.permitsMap.clickJoinMeeting),
          checkinUnlock: checkShowPermit(permissionList, this.permitsMap.checkinUnlock),
          deviceCtrl: checkShowPermit(permissionList, this.permitsMap.deviceCtrl),

          meetingType: checkShowPermit(permissionList, this.permitsMap.meetingType),
          meetingCost: checkShowPermit(permissionList, this.permitsMap.meetingCost),
          meetingGrade: checkShowPermit(permissionList, this.permitsMap.meetingGrade),
          timeRange: checkShowPermit(permissionList, this.permitsMap.timeRange),
        }
      },
      servicePermit: function () {
        const {meetingRooms, insideParticipant = [], customerGrade} = this.mDoc;
        return this.showPermits.serviceCall && assembleDemandOptions({
          reserveDoc: {
            room: (meetingRooms || [])[0] || {},
            customerGrade: customerGrade || 0,
            insideParticipant: insideParticipant,
          },
          serviceSetting: this.sysConfig.serviceSetting || {},
        }).length
      },

      controlIds: function () {
        const {teleconferenceInfo: tlcInfo, doorDeviceId} = this.mDoc;
        if (commonConfig.checkinStatus.includes(this.mDoc.status)) {
          return {
            tlc: this.showPermits.clickJoinMeeting && tlcInfo && tlcInfo.tlcDeviceId,
            door: this.showPermits.checkinUnlock && doorDeviceId,
            lvc: tlcInfo && tlcInfo.liveId
          }
        }

        return {
          lvc: tlcInfo && tlcInfo.liveId
        }
      },
      tlcConferenceNum: function () {
        return formatTlcConferenceNum(this.cellData.conferenceNum)
      },
      hasInvitationInfo() {
        return tlcConfig.invitation.hasOwnProperty(this.cellData.tlcManufacturer)
      },

      preNoticeChoiceMap() {
        const map = {};
        const {preNoticeChoices} = this.sysConfig;
        (preNoticeChoices || []).forEach(ele => map[ele.value] = ele.label);
        return map
      },
      endNoticeChoiceMap() {
        return commonConfig.endNoticeChoices
      },
      mtNotice() {
        const arr = [];
        if (this.cellData.preNoticeTime) arr.push(this.preNoticeChoiceMap[this.cellData.preNoticeTime]);
        if (this.cellData.endNoticeTime) arr.push(this.endNoticeChoiceMap[this.cellData.endNoticeTime]);
        return arr.join('、')
      },

      customerGradesMap() {
        const map = {};
        const {customerGrades} = this.sysConfig;
        (customerGrades || []).forEach(ele => map[ele.value] = ele.label);
        return map
      },
      btnList: function () {
        const list = [];
        const more = [];
        // 审核中仅可以取消
        if (this.mDoc.status === commonConfig.meetingStatus.UNDERREVIEW) {
          this.identity.editor && list.push(btnMapKeys.cancelMt);
          return {list, more}
        }
        // 未结束的会议
        if (this.normalStatus) {
          if (this.identity.editor) {
            list.push(btnMapKeys.editMt);
            if (this.mDoc.status === commonConfig.meetingStatus.MEETING) {
              list.unshift(btnMapKeys.endMt);
              this.dlySuggestions.length && list.push(btnMapKeys.delayMt);
            } else {
              list.unshift(btnMapKeys.cancelMt)
            }
          } else if (this.identity.owner) {
            list.push(btnMapKeys.reject, btnMapKeys.undetermined, btnMapKeys.accept)
          }
        }
        // 会议控制等操作
        if (this.identity.owner) {
          // 更改会议控制权限 Livia 2021-12-06
          if (this.identity.editor) {
            this.controlIds.door && more.push(btnMapKeys.checkinUnlock);
            (this.controlIds.tlc) && more.push(btnMapKeys.clickJoinMeeting);

            // // 启动/结束直播
            // if (this.controlIds.lvc) {
            //   more.push(btnMapKeys.startLvc);
            //   more.push(btnMapKeys.endLvc);
            // }
          }

          // 会中操作
          if (commonConfig.checkinStatus.includes(this.mDoc.status)) {
            this.servicePermit && more.push(btnMapKeys.serviceCall);
            this.cellData.roomId && this.showPermits.deviceCtrl && more.push(btnMapKeys.deviceCtrl)
          }
          this.normalStatus && this.cellData.roomId && this.showPermits.deviceRepair && more.push(btnMapKeys.deviceRepair);
        }
        return {list, more}
      },
      dlySuggestions: function () {
        const data = [];
        const startTime = moment(this.mDoc.startTime).format(momentFormat.time);
        let idx = 1;
        while (idx < 5) {
          const endTimeVal = moment(this.mDoc.endTime).add(idx * 30, 'm');
          data.push({
            startTime,
            endTime: endTimeVal.format(momentFormat.time),
            value: endTimeVal.valueOf(),
            hours: idx / 2,
          });
          idx++
        }
        return data
      },
      attendanceMemoNt() {
        if (this.attendanceInfo.main === btnMapKeys.accept) {
          return {
            label: "备注",
            placeholder: "可填写备注",
          }
        }
        return {
          label: "应答说明",
          placeholder: "必填，请填写不参会原因等",
          rule: [{required: true, message: '请填写应答说明'}]
        }
      },
      serviceList() {
        return this.serviceEdges.map(ele => {
          const sv = (ele.service.quickDemands || []).map(e => `${e.type} ${e.amount}${e.unit || '份'}`);
          ele.service.specificContent && sv.push(ele.service.specificContent);
          return {
            ...ele.service,
            svId: ele.cursor,
            statusCN: this.serviceStatusMap[ele.service.status] || ele.service.status,
            title: sv.join('；'),
            label: ele.service.initiator.name + ' - ' + moment(ele.service.createdDate).format(momentFormat.time),
            statusStyle: serviceConfig.statusStyle[ele.service.status] || serviceConfig.statusStyle.CANCELED,
            sumPrice: (ele.service.quickDemands || []).reduce((sum, e) => {
              return sum + (e.amount && e.price ? e.amount * e.price : 0)
            }, 0)
          }
        })
      },
      operateWord() {
        switch (this.operateFor) {
          case btnMapKeys.editMt:
            return "修改";
          case btnMapKeys.cancelMt:
            return "取消";
          default:
            return ""
        }
      },
      periodicActions() {
        return [
          {name: `仅${this.operateWord}此次会议`, isPeriodic: false},
          {name: `${this.operateWord}将来的周期系列会议`, isPeriodic: true},  // subname, 描述信息
        ]
      },
      periodicMtList() {
        return this.periodicMts.map(ele => formatMListDoc(ele, this))
      },
    },
    watch: {
      showAttendPopup(val) {
        if (val) {
          if (this.attendanceInfo.main === btnMapKeys.accept) {
            this.attendanceInfo.type = 'onSite'
          } else {
            this.attendanceInfo.type = this.attendanceInfo.main
          }
        }
      },
      'identity.owner'(val) {
        if (val) {
          this.tlcActName = ['1']
        }
      },
      'identity.ccTo'(val) {
        if (val) {
          this.tlcActName = ['1']
        }
      },
      $route(to, from) {
        if (to.name === from.name) {
          // console.log(this.$route.params.mid)
          this.mid = this.$route.params.mid;
          this.initMDoc();
          this.getMtServiceList()
        }
      }
    },
    mounted() {
      this.mid = this.$route.params.mid;
      this.initMDoc();
      this.getMtServiceList()
    },
    methods: {
      // 获取会议数据
      initMDoc(cb) {
        UILoader.load();
        meeting.queryDetail(this, {
          queryFilter: {
            selfCursor: this.mid,
            getIsUserCheckin: true
          }
        }).then(({searchMeeting: data = {}}) => {
          UILoader.unload();
          this.beforeQuery && (this.beforeQuery = false);
          const [edge] = (data.meetingEdges || []);
          if (edge && edge.cursor === this.mid && edge.meeting) {
            edge.meeting.mid = edge.cursor;
            this.mDoc = edge.meeting;
            this.getPeriodicMts();
            cb && cb()
          } else {
            vtToast("会议不存在")
          }
        }).catch(err => {
          UILoader.unload();
          // console.log(err);
          vtToast(err.message)
        });
      },
      getPeriodicMts() {
        const {isPeriodic, periodicInfo} = this.mDoc;
        const batchId = isPeriodic && periodicInfo && periodicInfo.batchId;
        if (!batchId) return;
        meeting.queryList(this, {queryFilter: {periodicBatchId: batchId}}).then(({searchMeeting: data = {}}) => {
          this.periodicMts = (data.meetingEdges || []);
        }).catch(err => {
        })
      },
      handleOperate(cmd) {
        this.operateFor = cmd;
        switch (cmd) {
          case btnMapKeys.editMt:
            if (this.mDoc.isPeriodic) {
              this.showPeriodicSheet = true;
              return
            }
            this.handleEdit();
            break;
          case btnMapKeys.endMt:
            this.handleEnd();
            break;
          case btnMapKeys.delayMt:
            if (this.dlySuggestions.length) {
              this.showDelayPopup = true;
            } else {
              vtToast("今日已无可延长时间");
            }
            break;
          case btnMapKeys.clickJoinMeeting:
          case btnMapKeys.checkinUnlock:
            this.sendCmd(cmd);
            break;
          case btnMapKeys.startLvc:
            this.setLvcStatus('start');
            break;
          case btnMapKeys.endLvc:
            this.setLvcStatus('end');
            break;
          case btnMapKeys.cancelMt:
            if (this.mDoc.isPeriodic) {
              this.showPeriodicSheet = true;
              return
            }
            this.showCancelPopup = true;
            break;
          case btnMapKeys.accept:
          case btnMapKeys.undetermined:
          case btnMapKeys.reject:
            this.attendanceInfo.main = cmd;
            this.attendanceInfo.memo = "";
            this.$refs.attendanceInfo && this.$refs.attendanceInfo.resetValidation();
            this.showAttendPopup = true;
            break;
          case btnMapKeys.serviceCall:
            this.$router.push({
              name: routerMeta.callService.name,
              params: {mid: this.mid},
            });
            break;
          case btnMapKeys.deviceCtrl:
            this.cellData.roomId && this.$router.push({
              name: routerMeta.deviceCtrl.name,
              params: {rid: this.cellData.roomId},
            });
            break;
          case btnMapKeys.deviceRepair:
            this.showRepairPopup = true;
            break;
          // 再约一场
          case btnMapKeys.copyMt: {
            // console.log(this.mDoc);
            const tlcInfo = this.mDoc.teleconferenceInfo || {};
            const lvcInfo = this.mDoc.liveConferenceInfo || {};
            const cpDoc = {
              mid: this.mDoc.mid,
              subject: this.mDoc.subject,
              startTime: this.mDoc.startTime,
              // endTime: this.mDoc.endTime,
              endTime: this.mDoc.applyEndTime,
              numberOfPeople: this.mDoc.numberOfPeople,
              meetingRooms: this.mDoc.meetingRooms,
              reviewProcessCode: this.mDoc.reviewProcessCode,
              insideParticipant: this.mDoc.insideParticipant,
              outsideParticipant: this.mDoc.outsideParticipant,
              reservedBy: this.mDoc.reservedBy,
              sponsor: this.mDoc.sponsor,
              initiator: this.mDoc.initiator,
              copyToUsers: this.mDoc.copyToUsers,
              preNoticeTime: this.mDoc.preNoticeTime,
              endNoticeTime: this.mDoc.endNoticeTime,
              customerGrade: this.mDoc.customerGrade,
              meetingRemarks: this.mDoc.meetingRemarks,
              extensionFieldJSON: this.mDoc.extensionFieldJSON,
              teleconferenceType: this.mDoc.teleconferenceType,
              teleconferenceInfo: {
                conferenceNum: 0,
                password: tlcInfo.password || "",
                conferenceCtrlPwd: tlcInfo.conferenceCtrlPwd || "",
                manufacturer: tlcInfo.manufacturer,
                settings: {...(tlcInfo.settings || {})}
              },
              enableLiveConference: this.mDoc.enableLiveConference,
              liveConferenceInfo: {
                password: lvcInfo.password || "",
                desc: lvcInfo.desc || "",
                manufacturer: lvcInfo.manufacturer,
              },
              service: {...this.mDoc.service},
              isRowSeat: this.mDoc.isRowSeat,
            };
            this.$store.commit('setReserveInfo', cpDoc);
            this.$router.push({
              name: routerMeta.meetingReserveFromMtDetail.name,
              params: {cmid: this.mid},
            });
            break;
          }
          case btnMapKeys.createOther: {  // 抄送人组织会议，复制主题、时间、视频会议
            const tlcInfo = this.mDoc.teleconferenceInfo || {};
            const cpDoc = {
              mid: this.mDoc.mid,
              subject: this.mDoc.subject,
              startTime: this.mDoc.startTime,
              endTime: this.mDoc.endTime,
              teleconferenceType: this.mDoc.teleconferenceType && "related" || "",  // 可以没有视频会议
              teleconferenceInfo: tlcInfo.conferenceNum && {
                ...tlcInfo,
                settings: {...(tlcInfo.settings || {})}
              } || null,
              ccFromMid: this.mid,
            };
            this.$store.commit('setReserveInfo', cpDoc);
            this.$router.push({
              name: routerMeta.meetingReserveFromMtDetail.name,
              params: {cmid: this.mid},
              query: {
                title: "组织会议",
              },
            });
            break;
          }
          default:
        }
      },
      // 延迟会议
      handleDelay(ele) {
        this.showDelayPopup = false;
        UILoader.load("执行中...");
        meeting.delayMeeting(this, {
          mid: this.mid,
          endTime: ele.value,
        }).then(({delayMeeting: resp = {}}) => {
          if (checkRespCorrect(resp, "保存失败")) {
            messageHdl({code: msgCode.SUCCESS});
            this.initMDoc()
          }
        }).catch(err => {
          messageHdl({msg: err.message});
        })
      },
      // 结束会议
      handleEnd() {
        frontConfirm({msg: `是否确认结束此会议？`}, () => {
          // console.log(doc);
          UILoader.load("执行中...");
          meeting.finishMeeting(this, {mid: this.mid}).then(({finishMeeting: resp = {}}) => {
            if (checkRespCorrect(resp, "保存失败")) {
              messageHdl({code: msgCode.SUCCESS});
              this.initMDoc()
            }
          }).catch(err => {
            messageHdl({msg: err.message});
          })
        })
      },
      // 编辑会议
      handleEdit(isPeriodic) {
        if (isPeriodic) {
          this.$router.push({name: routerMeta.periodicMeetingEdit.name, params: {mid: this.mid}});
          return
        }
        this.$router.push({name: routerMeta.meetingEdit.name, params: {mid: this.mid}})
      },
      handleDetail(mid) {
        this.showPeriodicList = false;
        this.$router.push({name: this.$route.name, params: {mid: mid}})
      },
      handleChkDetail() {
        this.$router.push({name: routerMeta.checkinRecordList.name, params: {mid: this.mid}});
      },
      async sendCmd(type) {
        // const {status, checkinInfo} = this.mDoc;
        // if (status !== commonConfig.meetingStatus.MEETING && (!checkinInfo || !checkinInfo.date)) {
        //   vtToast(`签到后可${this.controlBtnMap[type]} ~`);
        //   return
        // }
        let tip = "";
        let data;
        switch (type) {
          case btnMapKeys.clickJoinMeeting:
            tip = `是否确认加入视频会议 ${this.cellData.conferenceNum}？`;
            const tlcInfo = await queryTlcInfoByKey.call(this, ['conferenceNum', 'password'], this.mDoc.mid);
            data = {
              deviceId: this.controlIds.tlc || '',
              roomId: this.cellData.roomId,
              branchVenuesIds: this.cellData.branchVenues && this.cellData.branchVenues.map(ele => ele.id),
              method: "callJoin",
              params: JSON.stringify({
                number: tlcInfo && tlcInfo.conferenceNum || '',
                password: tlcInfo && tlcInfo.password || '',
              })
            };
            data = {
              deviceId: this.controlIds.tlc || '',
              roomId: this.cellData.roomId,
              branchVenuesIds: this.cellData.branchVenues && this.cellData.branchVenues.map(ele => ele.id),
              method: "callJoin",
              params: JSON.stringify({
                number: tlcInfo.conferenceNum,
                password: tlcInfo.password,
              })
            };
            break;
          case btnMapKeys.checkinUnlock:
            tip = "是否确认开锁？";
            data = {
              deviceId: this.controlIds.door,
              roomId: this.cellData.roomId,
              method: "setDoorUnLock",
            };
            break;
          default:
            return;
        }

        frontConfirm({msg: tip}, () => {
          UILoader.load("执行中...");
          meetingRoom.sendCommand(this, {data: data}).then(({sendCommand: resp = {}}) => {
            if (checkRespCorrect(resp, "控制失败")) {
              messageHdl({code: msgCode.SUCCESS, msg: "发送成功"});
            }
          }).catch(err => {
            messageHdl({msg: err.message})
          })
        })
      },
      setLvcStatus(status) {
        const title = this.sysFormTitles[`${status}Lvc`];
        frontConfirm({msg: `是否确认${title}？`}, () => {
          meeting.changeLvcStatus(this, {mid: this.mid, status: status}).then(({changeLvcStatus: resp = {}}) => {
            if (checkRespCorrect(resp, `${title}失败`)) {
              messageHdl({code: msgCode.SUCCESS, msg: `${title}成功`});
            }
          }).catch(err => {
            messageHdl({msg: err.message});
          })
        })
      },
      onAttendSubmit(info) {
        // console.log(info);
        this.showAttendPopup = false;
        UILoader.load("提交中...");
        meeting.attendanceResp(this, {
          mid: this.mid,
          ...info
        }).then(({attendanceResponse: resp = {}}) => {
          UILoader.unload();
          if (checkRespCorrect(resp, "提交失败")) {
            // messageHdl({code: msgCode.SUCCESS});
            this.initMDoc(() => {
              vtToast('应答成功 ~');
            })
          }
        }).catch(err => {
          messageHdl({msg: err.message});
        })
      },
      onPsGroupSubmit() {
        if (!this.psGroupName) {
          vtToast(`请填写会议群组名称`);
          return;
        }
        const destData = {
          name: this.psGroupName,
          members: (this.mDoc.insideParticipant || []).map(u => u.userId)
        };
        personalGroup.savePersonalGroup(this, {req: destData}).then(({savePersonalGroup: resp = {}}) => {
          if (checkRespCorrect(resp, "保存失败")) {
            messageHdl({code: msgCode.SUCCESS});
            this.showPsGroupSheet = false;
            this.psGroupName = ""
          }
        }).catch(err => {
          messageHdl({msg: err.message});
        })
      },
      confirmPeriodic(item) {
        // console.log(item);
        this.isSubUpdatePeriodic = !item.isPeriodic;
        switch (this.operateFor) {
          case btnMapKeys.editMt:
            this.handleEdit(item.isPeriodic);
            break;
          case btnMapKeys.cancelMt:
            this.showCancelPopup = true;
            break;
          default:
        }
      },
      // 获取该会议服务数据
      getMtServiceList() {
        service.queryList(this, {queryFilter: {meetingId: this.mid}}).then(({searchService: data = {}}) => {
          this.serviceEdges = (data.serviceEdges || []);
        }).catch(err => {
        })
      },
      lookOutUserInfo(ele, idx) {
        const filter = {
          mid: this.mid,
          key: 'tel',
          name: ele.name,
          tel: ele.tel
        }
        const val = this.cellData.outsideParticipant[idx]['tel'];
        const reg = /^[1-9]{2}[0-9][\*]{4}[0-9]{4}/
        if (reg.test(val)) {
          meeting.queryOutUserInfo(this, filter).then(({searchOutUserInfo: res}) => {
            if (res.code === 0) {
              const {data} = res;
              data && (this.cellData.outsideParticipant[idx]['tel'] = data['tel']);
            }
          })
        } else {
          this.cellData.outsideParticipant[idx]['tel'] = val.replace(/(\d{3})\d*(\d{4})/, '$1****$2')
        }
      }
    }
  }
</script>

<style lang="less">
  @main-color: #447EF2;

  .mt-header {
    background-color: @main-color;
    padding: 15px 20px;
    color: #FCFDFF;

    h3 {
      font-size: 18px;
    }

    .mt-header-time {
      margin: 20px 0 5px;
      display: flex;
      align-items: center;
      justify-content: center;

      .time-title {
        font-size: 28px;
        font-weight: bold;
      }

      .van-progress {
        height: 2px;
        width: 35%;
        margin: 0 5px;
      }

      .van-progress__pivot {
        background-color: white;
        color: @main-color;
        border-radius: 5px;
        padding: 0 3px;
        font-size: 12px
      }
    }

    .van-tag {
      padding: 4px 8px;
      border-radius: 5px;
    }

    .van-tag--plain::before {
      border: none;
    }
  }

  .mt-header::after {
    width: 100%;
    height: 75px;
    background-color: @main-color;
    content: ' ';
    position: absolute;
    left: 0;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
  }

  .ctn-danger,
  .ctn-default {
    .mt-header,
    .mt-header::after {
      background-color: #969799;
    }
  }

  .mt-container {
    background-color: #FCFDFF;
    border-radius: 5px;
    padding-bottom: 5px;

    .van-tag {
      padding: 4px 8px;
      border-radius: 5px;
    }


    .van-cell-group {
      border-radius: 5px;
      background-color: #FCFDFF;
    }

    .van-collapse-item__content,
    .van-collapse-item__wrapper,
    .van-cell {
      background-color: #FCFDFF;
    }

    .van-cell {
      padding-top: 5px;
      padding-bottom: 5px;
      /*font-size: 15px;*/
    }

    .van-collapse-item__content {
      padding: 0 16px 0 30px
    }

    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
      border: unset;
    }

    .van-cell::after {
      border-bottom: none;
    }

    .mt-btm {
      .van-button--default {
        color: #2D69E0;
        background: #F7F8FA;
        padding: 7px 15px;
        border: none;
      }

      button {
        border-radius: 3px;
      }
    }
  }

  .bg-white {
    .van-skeleton__title {
      margin: 0 auto;
    }

    .van-skeleton__row, .van-skeleton__title {
      height: 18px;
    }

    .van-skeleton__row:not(:first-child) {
      margin-top: 20px;
    }
  }

  .mt-sticky {
    .van-sticky--fixed {
      z-index: 0
    }
  }

  .participants-ctn {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;

    span::after {
      content: "、";
    }

    span:last-child::after {
      content: "";
    }
  }

  .van-popup, .mt-container {
    .iconfont {
      font-size: inherit;
    }
  }
</style>
